import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.alert_form', () => {
  import('./internal/alert_form').then(({ default: Component }) => Component());
});
